import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Select from 'react-select';
import {
  Button,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import { setFromErrors } from 'src/helpers';
import { useCreateSupervisorCourseApplyMutation } from 'src/rtk/features/myTraining/myTrainingApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import * as Yup from 'yup';
import loader from '../../assets/images/loader.gif';
import { SessionApplyComponent } from './SessionApplyComponent';

interface Props {
  isOpen: boolean;
  toggle: any;
  id: string;
  trainingType?: string;
  slotName?: string;
  fcpsPartOneInfo: any;
}

const tabStyling: any = {
  navTabs: {
    borderBottom: "1px solid black",
  },

  navItem: {
    marginRight: "4px",
  },

  navLink: {
    marginBottom: "-1px",
    cursor: "pointer",
  },

  navLinkActive: {
    marginBottom: "-1px",
    cursor: "pointer",
    color: "#000000",
    backgroundColor: "#ffffff",
    borderColor: "#ced4da #ced4da #fff",
  }
};

const CoreTrainingLogbookModal = (props: Props) => {
  const { isOpen, toggle, id, trainingType, slotName, fcpsPartOneInfo } = props;

  const initialValues: SupervisorCourseApply = {
    exam_course_id: '',
    supervisor_id: '',
    start_date: '',
    end_date: '',
    course_session: '',
    session_year: '',
    institute_name: '',
    department: '',
    training_institute_type: '',
    trainee_category: '',
    income_category: '',
    release_order: '',
    joining_letter: '',
    office_order: '',
  };

  const [instituteName, setInstituteName] = useState('');
  const [activeTab, setActiveTab] = useState<string>('choice1');
  const [instituteForDeparment, setInstituteForDeparment] = useState('');

  const [selectedInstitueCategory, setSelectedInstituteCategory] = useState<any>('');
  const [selectedTraineeCategory, setSelectedTraineeCategory] = useState<any>('');
  const [selectedIncomeCategory, setSelectedIncomeCategory] = useState<any>('');

  const [changeInstituteOption, setChangeInstituteOption] = useState<string>('no');
  // const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  // const currentYear = new Date().getFullYear();

  const [createSupervisorCourseApply, { isError, isSuccess, error, isLoading }] =
    useCreateSupervisorCourseApplyMutation();

  const { data: instituteLookupData } = useGetOrganizationsQuery();

  const allInstitute: SelectOption[] =
    instituteLookupData?.data?.map((institute) => ({
      value: institute.id!,
      label: institute.organization_name,
    })) || [];

  const sessionOptions = [
    { label: 'Select Session', value: '' },
    { label: 'January', value: 'January-June' },
    { label: 'July', value: 'July-December' },
  ];

  const allTrainingInstituteCategory: SelectOption[] = [
    { label: 'Sadar Hospital/District Hospital/Zila Hospital', value: 'Sadar Hospital/District Hospital/Zila Hospital' },
    { label: 'Government Medical College Hospital (under MoHFW)', value: 'Government Medical College Hospital (under MoHFW)' },
    { label: 'Public Medical University', value: 'Public Medical University' },
    { label: 'Government Postgraduate Medical Institute (under MoHFW)', value: 'Government Postgraduate Medical Institute (under MoHFW)' },
    { label: 'Government Institute/Hospital (under MoHFW)', value: 'Government Institute/Hospital (under MoHFW)' },
    { label: 'Government Institute/Hospital (under Ministry of Defence)', value: 'Government Institute/Hospital (under Ministry of Defence)' },
    { label: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)', value: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)' },
    { label: 'Government Hospital (under Ministry of public Administration)', value: 'Government Hospital (under Ministry of public Administration)' },
    { label: 'Non-Government Postgraduate Medical Institute/Hospital', value: 'Non-Government Postgraduate Medical Institute/Hospital' },
    { label: 'Non-Governmnet Charitable Organization', value: 'Non-Governmnet Charitable Organization' },
    { label: 'Private Medical College Hospital', value: 'Private Medical College Hospital' },
    { label: 'Private Hospital', value: 'Private Hospital' },
    { label: 'Foreign Institute/Hospital', value: 'Foreign Institute/Hospital' },
  ];

  const allTraineeCategory: SelectOption[] = [
    { label: 'Trainees receiving allowances in government institutions', value: 'allocated_institute' },
    { label: 'Trainees receiving allowances by private institutions', value: 'non_government_institution_hmo' },
    { label: 'Trainees in government employment', value: 'employed_government_organization' },
    { label: 'Trainees in private employment', value: 'employed_non_government_organization' },
  ];

  const allIncomeCategory: SelectOption[] = [
    { label: 'Yes, involvement in Job/Income generating activities', value: 'Yes' },
    { label: 'No, not involvement in Job/Income generating activities', value: 'No' },
  ];


  const err: CustomError = error as CustomError;

  const {
    handleSubmit,
    getFieldProps,
    handleChange,
    touched,
    errors,
    values,
    resetForm,
    setErrors,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      supervisor_id: Yup.string().required('Select Supervisor'),
      course_session: Yup.string().required('Select Session'),
      start_date: Yup.string().required('Select Statring Date'),
      end_date: Yup.string().required('Select End Date'),
      training_institute_type: Yup.string().required('Select Institute Category'),
      trainee_category: Yup.string().required('Select Trainee Category'),
      income_category: Yup.string().required('Select Income Category'),
      release_order: Yup.mixed().when([], {
        is: () => changeInstituteOption === 'yes',
        then: schema => schema.required('Release Order is required'),
      }),
      joining_letter: Yup.mixed().required('Joining Letter is required'),
    }),

    onSubmit: (values: any) => {
      values.exam_course_id = id;

      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });
      createSupervisorCourseApply(formData);
    },
  });

  useEffect(() => {
    if (selectedTraineeCategory?.value === 'allocated_institute') {
      const today = new Date();
      const month = today.getMonth() + 1; // 1 - 12
      const year = today.getFullYear();

      if (month >= 1 && month <= 6) {
        // January to June Session
        setFieldValue("start_date", `${year}-01-01`);
        setFieldValue("end_date", `${year}-06-30`);
      } else {
        // July to December Session
        setFieldValue("start_date", `${year}-07-01`);
        setFieldValue("end_date", `${year}-12-31`);
      }
    } else {
      setFieldValue("start_date", '');
      setFieldValue("end_date", '');
    }
  }, [selectedTraineeCategory]);

  const handleFromDateChange = (event: any) => {
    // const selectedSession = event.target.value;

    // if (selectedSession === "January-June") {
    //   setFromDate(new Date(currentYear, 0, 2));
    //   setToDate(new Date(currentYear, 6, 1));
    // } else if (selectedSession === "July-December") {
    //   setFromDate(new Date(currentYear, 6, 2));
    //   setToDate(new Date(currentYear, 12, 1));
    // }
    // else{
    //   setFromDate(null);
    //   setToDate(null);
    // }
    if (event.target.value !== '') {
      const fromDate = new Date(event.target.value);
      const newToDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 6, fromDate.getDate());
      // newToDate.setDate(newToDate.getDate() + 180);
      setToDate(newToDate);
    } else {
      setToDate(null);
    }
  };

  useEffect(() => {
    if (toDate) {
      setFieldValue('end_date', toDate?.toISOString()?.slice(0, 10) || "");
    }
  }, [toDate]);

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Core Training Logbook Created successfully');
      toggle(false);
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);

  const handleInstitute = (e: any) => {
    setInstituteName(e.target.value);
    setInstituteForDeparment(e.target.value);
  };

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    if (selectedInstitueCategory !== '') {
      setFieldValue('training_institute_type', selectedInstitueCategory?.value);
    }
  }, [selectedInstitueCategory]);

  useEffect(() => {
    if (!selectedTraineeCategory) {
      setFieldValue('trainee_category', '');
      setSelectedIncomeCategory('');
      setFieldValue('income_category', '');
      return;
    }

    setFieldValue('trainee_category', selectedTraineeCategory.label);

    const incomeCategoryValue = selectedTraineeCategory.value === 'allocated_institute' ? 'No' : 'Yes';
    const incomeCategory = allIncomeCategory.find(
      (option) => option.value === incomeCategoryValue
    );

    setSelectedIncomeCategory(incomeCategory || '');
    setFieldValue('income_category', incomeCategoryValue);
  }, [selectedTraineeCategory]);

  useEffect(() => {
    if (selectedIncomeCategory !== '') {
      setFieldValue('income_category', selectedIncomeCategory?.value);
    }
  }, [selectedIncomeCategory]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={'static'} size="lg">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <ModalHeader className="slot-apply-header" toggle={toggle}>Apply for {trainingType} - {slotName}</ModalHeader>

      <ModalBody>
        <div>
          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className='mb-3'>
                  <div className="input-group-with-label">
                    <div className="m-0">
                      <Label className="form-Label">FCPS Part-1 Passing Session</Label>
                      <Input
                        className="form-control"
                        type="text"
                        name="course_session"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        readOnly
                        value={fcpsPartOneInfo?.fcps_part1_info?.fcps_part_one_passing_session}
                      />
                    </div>
                    <div className="m-0">
                      <Label className="form-Label">FCPS Part-1 Passing Year</Label>
                      <Input
                        className="form-control"
                        type="text"
                        name="course_year"
                        onChange={handleChange}
                        readOnly
                        value={fcpsPartOneInfo?.fcps_part1_info?.fcps_part_one_passing_year}
                      />
                    </div>
                  </div>
                </div>
                <div className='mb-3'>
                  <Label className="form-label required-field">Trainee Category</Label>
                  <Select
                    isClearable={true}
                    isSearchable={true}
                    value={selectedTraineeCategory}
                    onChange={setSelectedTraineeCategory}
                    options={allTraineeCategory}
                    placeholder='Select...'
                    name="trainee_category"
                  />
                  {errors.trainee_category && touched.trainee_category ? (
                    <div className="text-danger">{errors.trainee_category as string}</div>
                  ) : null
                  }
                </div>
                <div className='mb-3'>
                  <div className="input-group-with-label">
                    <div className="m-0">
                      <Label className="form-Label required-field">From Date</Label>
                      <Input
                        className="form-control"
                        type="date"
                        name="start_date"
                        onChange={(e) => {
                          handleFromDateChange(e);
                          handleChange(e);
                        }}
                        value={values.start_date}
                        disabled={selectedTraineeCategory?.value === 'allocated_institute'}
                      // min={new Date(new Date().getFullYear(), new Date().getMonth() - 1, 2).toISOString().slice(0, 10)}
                      />
                      {errors.start_date && touched.start_date ? (
                        <div className="text-danger">{errors.start_date as string}</div>
                      ) : null}
                    </div>
                    <div className="m-0">
                      <Label className="form-Label required-field">To Date</Label>
                      <Input
                        className="form-control"
                        type="date"
                        name="end_date"
                        // onChange={handleChange}
                        value={values.end_date}
                        disabled={selectedTraineeCategory?.value === 'allocated_institute'}
                      />
                      {errors.end_date && touched.end_date ? (
                        <div className="text-danger">{errors.end_date as string}</div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <Label className="form-label required-field">Institute Category</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedInstitueCategory}
                      onChange={setSelectedInstituteCategory}
                      options={allTrainingInstituteCategory}
                      placeholder='Select...'
                      name="training_institute_type"
                    />
                    {
                      errors.training_institute_type && touched.training_institute_type ? (
                        <div className="text-danger">{errors.training_institute_type as string}</div>
                      ) : null
                    }
                  </div>

                  <div className='col-md-6 mb-3'>
                    <Label className="form-label required-field">Income Category</Label>
                    <Select
                      isClearable={false}
                      isSearchable={false}
                      value={selectedIncomeCategory}
                      options={allIncomeCategory}
                      placeholder='Select...'
                      name="income_category"
                      isDisabled
                    />
                    {errors.income_category && touched.income_category ? (
                      <div className="text-danger">{errors.income_category as string}</div>
                    ) : null
                    }
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <Label className="form-label">Are You Changing Your Institute? <i className="fas fa-info-circle" title="If you are changing your Institute, then select Yes."></i> &nbsp;</Label>
                    <div className='form-check form-check-inline'>
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="change_institute"
                        id="yes"
                        value="yes"
                        checked={changeInstituteOption === 'yes'}
                        onChange={() => setChangeInstituteOption('yes')}
                      />
                      <Label className="form-check-label" htmlFor="yes">Yes</Label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="change_institute"
                        id="no"
                        value="no"
                        checked={changeInstituteOption === 'no'}
                        onChange={() => setChangeInstituteOption('no')}
                      />
                      <Label className="form-check-label" htmlFor="no">No</Label>
                    </div>
                  </div>

                </div>

                <div className='row mb-3'>
                  <div className='col-md-6'>
                    <Label className="form-label required-field">
                      Joining Letter
                    </Label>
                    <input
                      name="joining_letter"
                      type="file"
                      className="form-control"
                      placeholder="Upload"
                      onChange={(e: any) => {
                        setFieldValue('joining_letter', e.target.files[0]);
                      }}
                    ></input>
                    {errors.joining_letter && touched.joining_letter ? (
                      <div className="text-danger">{errors.joining_letter as string}</div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <Label className="form-label">
                      Office Order
                    </Label>
                    <input
                      name="office_order"
                      type="file"
                      className="form-control"
                      placeholder="Upload"
                      onChange={(e: any) => {
                        setFieldValue('office_order', e.target.files[0]);
                      }}
                    ></input>
                    {errors.office_order && touched.office_order ? (
                      <div className="text-danger">{errors.office_order as string}</div>
                    ) : null}
                  </div>
                  {changeInstituteOption === 'yes' && (
                    <div className='col-md-6'>
                      <Label className="form-label required-field">
                        Release Order
                      </Label>
                      <input
                        name="release_order"
                        type="file"
                        className="form-control"
                        placeholder="Upload"
                        onChange={(e: any) => {
                          setFieldValue('release_order', e.target.files[0]);
                        }}
                      ></input>
                      {errors.release_order && touched.release_order ? (
                        <div className="text-danger">{errors.release_order as string}</div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <Nav tabs>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice1' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice1')}
                    >
                      1st Choice
                    </NavLink>
                  </NavItem>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice2' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice2')}
                    >
                      2nd Choice
                    </NavLink>
                  </NavItem>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice3' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice3')}
                    >
                      3rd Choice
                    </NavLink>
                  </NavItem>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice4' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice4')}
                    >
                      4th Choice
                    </NavLink>
                  </NavItem>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice5' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice5')}
                    >
                      5th Choice
                    </NavLink>
                  </NavItem>
                  <NavItem style={tabStyling.navItem}>
                    <NavLink
                      style={activeTab === 'choice6' ? tabStyling.navLinkActive : tabStyling.navLink}
                      onClick={() => toggleTab('choice6')}
                    >
                      6th Choice
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <TabContent activeTab={activeTab} className='border border-top-0 pt-3 shadow-lg'>
                  <TabPane tabId="choice1">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                  <TabPane tabId="choice2">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                  <TabPane tabId="choice3">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                  <TabPane tabId="choice4">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                  <TabPane tabId="choice5">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                  <TabPane tabId="choice6">
                    <SessionApplyComponent
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      allInstitute={allInstitute}
                      fcpsPartOneInfo={fcpsPartOneInfo}
                    />
                  </TabPane>
                </TabContent>
              </div>
            </div>
            <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-3">
              <Button color="danger" onClick={toggle}>
                Close
              </Button>

              <Button color="success" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CoreTrainingLogbookModal;
